import { useState, useEffect } from 'react';

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 500);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!isVisible) return null;

  return (
    <button
      onClick={scrollToTop}
      className="fixed bottom-24 right-6 z-40 w-12 h-12 flex items-center justify-center bg-primary text-white rounded-full shadow-lg hover:bg-[#1873CC] transition-all cursor-pointer"
      aria-label="Volver arriba"
    >
      <i className="ri-arrow-up-line text-xl"></i>
    </button>
  );
};

export default ScrollToTop;